import ErrorMessage from '@app/components/atoms/ErrorMessage/ErrorMessage'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Checkbox from '@mui/material/Checkbox'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Typography from '@mui/material/Typography'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const not = (a, b) => a.filter((value) => -1 === b.indexOf(value))

const intersection = (a, b) => a.filter((value) => -1 !== b.indexOf(value))

const union = (a, b) => [...a, ...not(b, a)]

const POSSection = ({ errors, setValue, pos, posMerchant }) => {
  const { t } = useTranslation()
  const [checked, setChecked] = useState([])
  const [left, setLeft] = useState(
    pos.filter((pos) => !posMerchant.find((posMerchant) => posMerchant.id === pos.id)).map((item) => item.id)
  )
  const [right, setRight] = useState(posMerchant.map((item) => item.id))
  const leftChecked = intersection(checked, left)
  const rightChecked = intersection(checked, right)

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value)
    const newChecked = [...checked]

    if (-1 === currentIndex) {
      newChecked.push(value)
    } else {
      newChecked.splice(currentIndex, 1)
    }

    setChecked(newChecked)
  }

  const numberOfChecked = (items) => intersection(checked, items).length

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items))
    } else {
      setChecked(union(checked, items))
    }
  }

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked))
    setLeft(not(left, leftChecked))
    setChecked(not(checked, leftChecked))
    setValue('pos', right.concat(leftChecked))
  }

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked))
    setRight(not(right, rightChecked))
    setValue('pos', not(right, rightChecked))
    setChecked(not(checked, rightChecked))
  }

  const customList = (title, items) => (
    <Card>
      <CardHeader
        avatar={
          <Checkbox
            checked={numberOfChecked(items) === items.length && 0 !== items.length}
            disabled={0 === items.length}
            indeterminate={numberOfChecked(items) !== items.length && 0 !== numberOfChecked(items)}
            inputProps={{
              'aria-label': 'all items selected',
            }}
            onClick={handleToggleAll(items)}
          />
        }
        subheader={`${numberOfChecked(items)}/${items.length} ${t('POS.SELECTED').toLowerCase()}`}
        sx={{ px: 2, py: 1 }}
        title={title}
      />
      <Divider />
      <List
        dense
        component="div"
        role="list"
        sx={{
          width: 250,
          height: 230,
          bgcolor: 'background.paper',
          overflow: 'auto',
        }}
      >
        {items.map((value) => {
          const labelId = `transfer-list-all-item-${value}-label`

          return (
            <ListItem button key={value} role="listitem" onClick={handleToggle(value)}>
              <ListItemIcon>
                <Checkbox
                  disableRipple
                  checked={-1 !== checked.indexOf(value)}
                  inputProps={{
                    'aria-labelledby': labelId,
                  }}
                  tabIndex={-1}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={`${pos.find(({ id }) => id === value)?.address}`} />
            </ListItem>
          )
        })}
        <ListItem />
      </List>
    </Card>
  )

  return (
    <Grid container spacing={1}>
      <Grid item lg={3} md={6} sm={12} xs={12}>
        <Typography>{t('POS.CHOOSE_POS')} *</Typography>
      </Grid>

      <Grid item lg={9} md={6} sm={12} xs={12}>
        <Grid container alignItems="center" spacing={1}>
          <Grid item>{customList(t('POS.CHOICES'), left)}</Grid>
          <Grid item>
            <Grid container alignItems="center" direction="column">
              <Button
                aria-label="move selected right"
                disabled={0 === leftChecked.length}
                size="small"
                sx={{ my: 0.5 }}
                variant="outlined"
                onClick={handleCheckedRight}
              >
                &gt;
              </Button>
              <Button
                aria-label="move selected left"
                disabled={0 === rightChecked.length}
                size="small"
                sx={{ my: 0.5 }}
                variant="outlined"
                onClick={handleCheckedLeft}
              >
                &lt;
              </Button>
            </Grid>
          </Grid>
          <Grid item>{customList(t('POS.CHOSEN'), right)}</Grid>
          {errors.pos && (
            <Grid item xs={12}>
              <ErrorMessage variant="caption">{errors.pos?.message}</ErrorMessage>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}
export default POSSection
